

    //**  IMAGENES ES **//
    
    var TerminosEs = "";
    var urlBannerCFDesktop = "https://cdn.shopify.com/s/files/1/0935/8216/files/2800x1040_desktop_codigo_favorito_ES_UD_80abd8ff-a8bc-4578-a8d6-8edbaef4866c.png?v=1750601672";
    var urlBannerCFMovil = "https://cdn.shopify.com/s/files/1/0935/8216/files/833x1458_mobile_codigo_favorito_ES_UD_a328b5ca-c8af-4fed-adb2-4cebb98a5373.png?v=1750601667";

    var urlBannerPaleolifeDesktop = "https://cdn.shopify.com/s/files/1/0935/8216/files/2800x1040_desktop_paleolife_ES_UD_8ec3a6e5-6e18-41dd-8eca-2302dac48da0.png?v=1750601672";
    var urlBannerPaleolifeMovil = "https://cdn.shopify.com/s/files/1/0935/8216/files/833x1458_mobile_codigo_favorito_ES_b92b1a76-48b6-43e4-ac5b-381aa6f336c8.png?v=1748438638";

     var urlBannerCusiDesktop = "https://cdn.shopify.com/s/files/1/0935/8216/files/2800x1040_desktop_cusifit_ES_UD_9df0e6a4-b289-4029-9544-cd1617ec9575.png?v=1750601673";
    var urlBannerCusiMovil = "https://cdn.shopify.com/s/files/1/0935/8216/files/833x1458_mobile_cusifit_ES_UD_f2c0f979-18ce-4e47-8c8a-ea580007a685.png?v=1750601667";

    var urlBannerSamarDesktop = "https://cdn.shopify.com/s/files/1/0935/8216/files/2800x1040_desktop_soysaludable_ES_UD_20db7aef-0107-4da7-a99c-c3bf4e5abf14.png?v=1750601672";
    var urlBannerSamarMovil = "https://cdn.shopify.com/s/files/1/0935/8216/files/833x1458_mobile_soysaludable_ES_UD_9a1add8e-addf-454a-b975-bb6fd255bc2d.png?v=1750601667";

    var urlBannerErikaDesktop = "https://cdn.shopify.com/s/files/1/0935/8216/files/2800x1040_desktop_erika_ES_UD_f7e1787e-ff00-4e24-9b6e-42b9142020e6.png?v=1750601672";
    var urlBannerErikaMovil = "https://cdn.shopify.com/s/files/1/0935/8216/files/833x1458_mobile_erika_ES_UD_cfefa93c-bb58-4606-aa10-cea9ffb65888.png?v=1750601669";
 
    var urlBannerExplicativaDesktop = "https://cdn.shopify.com/s/files/1/0935/8216/files/seccion_es_desktop_2d845323-4304-4a49-8626-15aac4793187.jpg?v=1749822710";
    var urlBannerExplicativaMovil = "https://cdn.shopify.com/s/files/1/0935/8216/files/seccion_es_mobile_029f444f-917a-4fdf-9c3e-884f32ceb749.jpg?v=1749822710";

    var urlBannerExplicativaDesktopCusi = "https://cdn.shopify.com/s/files/1/0935/8216/files/seccion_es_desktop_2d845323-4304-4a49-8626-15aac4793187.jpg?v=1749822710";
    var urlBannerExplicativaMovilCusi = "https://cdn.shopify.com/s/files/1/0935/8216/files/seccion_es_mobile_029f444f-917a-4fdf-9c3e-884f32ceb749.jpg?v=1749822710";

    var urlBannerExplicativaSamarDesktop = "https://cdn.shopify.com/s/files/1/2632/8386/files/seccion_samar_desktop_8a47bfba-ae12-4488-97de-d5840e3684eb.jpg?v=1749825625";
    var urlBannerExplicativaSamarMovil = "https://cdn.shopify.com/s/files/1/2632/8386/files/seccion_samar_mobile_495f5852-fb48-4a74-b9f6-7cce21e35913.jpg?v=1749825625";

    var urlBannerProductoDesktop = "https://cdn.shopify.com/s/files/1/0935/8216/files/1400x260_desktop_codigo_favorito_ES_UD_2c50cb24-222f-4f7f-aa19-bc5dc95101b9.png?v=1750602013";
    var urlBannerProductoMovil = "https://cdn.shopify.com/s/files/1/0935/8216/files/1200x497_mobile_codigo_favorito_ES_UD_7b49596b-e4ee-4c6f-8e3f-de17f46cc49c.png?v=1750602013";


    //**--------------  IMAGENES EN  --------------------**//


    var urlBannerExplicativaDesktopEn = "https://cdn.shopify.com/s/files/1/0935/8216/files/seccion_en_desktop_292a741f-45ab-4a7c-b6f9-3af96115e30f.jpg?v=1749822710";
    var urlBannerExplicativaMovilEn = "https://cdn.shopify.com/s/files/1/0935/8216/files/seccion_en_mobile_32635bee-ce89-4884-a464-65a71c833e77.jpg?v=1749822710";

    var urlBannerPaleolifeDesktopEn = "https://cdn.shopify.com/s/files/1/0935/8216/files/2800x1040_desktop_paleolife_EN_UD_b4414657-95b3-4efe-a9fc-bea4f5980f91.png?v=1750601672";
    var urlBannerPaleolifeMovilEn = "https://cdn.shopify.com/s/files/1/0935/8216/files/833x1458_mobile_paleolife_EN_UD_e1446a00-4c59-4545-8a1c-3f0275a0d851.png?v=1750601667";

    var urlBannerProductoDesktopEn = "https://cdn.shopify.com/s/files/1/0935/8216/files/1400x260_desktop_plaelife_EN_UD.png?v=1750602013";
    var urlBannerProductoMovilEn = "https://cdn.shopify.com/s/files/1/0935/8216/files/1200x497_mobile_paleolife_EN_UD_19c48c7f-1f2f-4471-b400-8db1826917c7.png?v=1750602009";


    //**--------------  DECLARACIONES DE VARIABLES DE IDS  --------------------**//


    var BannerSliderhome = document.getElementById("shopify-section-template--16777689596139__landing_slider_Jc9prX");
    //var BannerSliderhomeControls = document.getElementsByClassName("slider-mobile-gutter");
    var BannerSliderhomeEn = document.getElementById("shopify-section-template--16703710494960__landing_slider_4LdkWp");
    var ContenedorBannersHomeEs = document.getElementById("shopify-section-template--16777689596139__custom_liquid_a9ehmt");
  
    var BannerPaleolifeDesktop = document.getElementById("BannerPaleolifeDesktop");
    var BannerPaleolifeMovil = document.getElementById("BannerPaleolifeMovil");

    var BannerCFDesktopHome = document.getElementById("BannerCFDesktop");
    var BannerCFMovilHome = document.getElementById("BannerCFMovil");

    var BannerCFDesktophomeContenedor= document.getElementById("shopify-section-template--16777689596139__custom_liquid_a9ehmt");
    var BannerCFMovilhomeContenedor= document.getElementById("shopify-section-template--16777689596139__custom_liquid_fNxEMb");

    var BannerExplicativaDesktopContenedor = document.getElementById("shopify-section-template--16777689596139__custom_liquid_74x8xW");
    var BannerExplicativaMovilContenedor = document.getElementById("shopify-section-template--16777689596139__custom_liquid_ERdJ7M");

    var BannerCFDesktop = document.getElementById("BannerCFDesktop");
    var BannerCFMovil = document.getElementById("BannerCFMovil");

    var BannerCusiDesktop = document.getElementById("BannerCusiDesktop");
    var BannerCusiMovil = document.getElementById("BannerCusiMovil");

    var BannerSamarDesktop = document.getElementById("BannerSamarDesktop");
    var BannerSamarMovil = document.getElementById("BannerSamarMovil");

    var BannerErikaDesktop = document.getElementById("BannerErikaDesktop");
    var BannerErikaMovil = document.getElementById("BannerErikaMovil");

    var BannerExplicativaDesktop = document.getElementById("BannerExplicativaDesktop");
    var BannerExplicativaMovil = document.getElementById("BannerExplicativaMovil");

    var BannerExplicativaDesktopCusi = document.getElementById("BannerExplicativaDesktopCusi");
    var BannerExplicativaMovilCusi = document.getElementById("BannerExplicativaMovilCusi");

    var BannerExplicativaSamarDesktop = document.getElementById("BannerExplicativaSamarDesktop");
    var BannerExplicativaSamarMovil = document.getElementById("BannerExplicativaSamarMovil");



    var BannerProductoDesktop = document.getElementById("BannerProductoDesktop");
    var BannerProductoMovil = document.getElementById("BannerProductoMovil");

    var BannerExplicativaDesktopEn = document.getElementById("BannerExplicativaDesktopEn");
    var BannerExplicativaMovilEn = document.getElementById("BannerExplicativaMovilEn");

    var BannerPaleolifeDesktopEn = document.getElementById("BannerPaleolifeDesktopEn");
    var BannerPaleolifeMovilEn = document.getElementById("BannerPaleolifeMovilEn");

    var BannerProductoDesktopEn = document.getElementById("BannerProductoDesktopEn");
    var BannerProductoMovilEn = document.getElementById("BannerProductoMovilEn");

    var BannerProductoDesktopSec = document.getElementById("BannerProductoDesktopSec");
    var BannerProductoDesktopSecEn = document.getElementById("BannerProductoDesktopSecEn");

    var Link = document.getElementById("link");


    var promo = obtenerEstadoDePromo();

    var landings = landings();

    var promoSamar = obtenerEstadoDePromoSamar();

    var promoCusi = obtenerEstadoDePromoCusi();

    var promoErika = obtenerEstadoDePromoErika();
   
    var DivTerminosPaleo = document.getElementById('DivTerminosPaleo');

    var DivTerminosPaleoEn = document.getElementById('DivTerminosPaleoEn');

    var DivTerminosCF = document.getElementById('DivTerminosCF');

    var DivTerminosEn = document.getElementById('DivTerminosEn');

    var DivTerminosSamar = document.getElementById('DivTerminosSamar');

    var DivTerminosCusi = document.getElementById('DivTerminosCusi');


    var videoCusi = document.getElementById('videoCusi');
    var videoSamar = document.getElementById('videoSamar');
    var ImageErika = document.getElementById('ImageErika');
    var ImageErikaDesktop = document.getElementById('ImageErikaDesktop');



  if (DivTerminosSamar !== null) {
  BannerSamarDesktop.src = urlBannerSamarDesktop;
  BannerSamarMovil.src = urlBannerSamarMovil;
  DivTerminosSamar.innerHTML = TerminosEs;  
  } 

  if (DivTerminosCusi !== null) {
  BannerCusiDesktop.src = urlBannerCusiDesktop;
  BannerCusiMovil.src = urlBannerCusiMovil;
  DivTerminosCusi.innerHTML = TerminosEs;
  } 

  if (DivTerminosCF !== null) {
  BannerCFDesktop.src = urlBannerCFDesktop;
  BannerCFMovil.src = urlBannerCFMovil;
  DivTerminosCF.innerHTML = TerminosEs;
  } 




  if (DivTerminosPaleo !== null) {
  BannerPaleolifeDesktop.src = urlBannerPaleolifeDesktop;
  BannerPaleolifeMovil.src = urlBannerPaleolifeMovil;
  DivTerminosPaleo.innerHTML = TerminosEs;
  } 

  if (DivTerminosPaleoEn !== null) {
  BannerPaleolifeDesktopEn.src = urlBannerPaleolifeDesktopEn;
  BannerPaleolifeMovilEn.src = urlBannerPaleolifeMovilEn;
  DivTerminosPaleo.innerHTML = TerminosEs;
  } 

  if (BannerPaleolifeDesktopEn !== null) {
  
  BannerPaleolifeDesktopEn.src = urlBannerPaleolifeDesktopEn;
  BannerPaleolifeMovilEn.src = urlBannerPaleolifeMovilEn;
  } 


  if (DivTerminosPaleo !== null) {
    DivTerminosPaleo.innerHTML = TerminosEs;
  }  


//INICIO CONDICIONAL PROMO ON //

if (promo === 'on') {

      if (BannerCFDesktop !== null) {
console.log ('Home paleolife');
      BannerSliderhome.style.display = 'none'; 
      //BannerSliderhomeControls.style.display = 'none'; 
      BannerCFDesktop.src = urlBannerCFDesktop;
      BannerCFMovil.src = urlBannerCFMovil;  
        BannerExplicativaDesktop.src = urlBannerExplicativaDesktop;
  BannerExplicativaMovil.src = urlBannerExplicativaMovil;    
 
       if (window.innerWidth <= 760) {
         BannerCFDesktop.style.display = 'none';  
          BannerExplicativaDesktop.style.display = 'none';  
         BannerCFMovil.style.display = 'block'; 
         BannerExplicativaMovil.style.display = 'block'; 
         
        }
      if (window.innerWidth >= 761) {
        BannerCFMovil.style.display = 'none'; 
         BannerExplicativaMovil.style.display = 'none'; 
          BannerCFDesktop.style.display = 'block';  
          BannerExplicativaDesktop.style.display = 'block';  
      }

             if (landings === 'no') {
        Link.href = "#Slider-template--16777689596139__featured_collection_nVKTkV";
      }  
     if (landings === 'yes') {
        Link.href = "https://paleolf.com/pages/oferta-especial";
      }    
    
  } 


  

    if (BannerProductoDesktop !== null) {
     
      BannerProductoMovil.src = urlBannerProductoMovil;
      BannerProductoDesktop.src = urlBannerProductoDesktop;

     if (window.innerWidth <= 760) {
         BannerProductoMovil.style.display = 'block';  
        }
      if (window.innerWidth >= 761) {
          BannerProductoDesktop.style.display = 'block';  
      }
    } 


  if (BannerCFDesktopHome !== null) {
  
  BannerCFDesktopHome.src = urlBannerCFDesktop;
  BannerCFMovilHome.src = urlBannerCFMovil;
      
   if (window.innerWidth <= 760) {
         BannerCFMovilHome.style.display = 'block';  
         BannerCFDesktopHome.style.display = 'none'; 
        }
    if (window.innerWidth >= 761) {
          BannerCFDesktopHome.style.display = 'block';  
          BannerCFMovilHome.style.display = 'none'; 
      }
  } 


    if (BannerProductoDesktopEn !== null) {
      
      BannerProductoMovilEn.src = urlBannerProductoMovilEn;
      BannerProductoDesktopEn.src = urlBannerProductoDesktopEn;

     if (window.innerWidth <= 760) {
         BannerProductoMovilEn.style.display = 'block';  
        }
      if (window.innerWidth >= 761) {
          BannerProductoDesktopEn.style.display = 'block';  
      }
     } 


    if (BannerPaleolifeDesktopEn !== null) {
      console.log('Home .us');
        BannerSliderhomeEn.style.display = 'none'; 
        BannerExplicativaDesktopEn.src = urlBannerExplicativaDesktopEn;
        BannerExplicativaMovilEn.src = urlBannerExplicativaMovilEn;    

     if (window.innerWidth <= 760) {
          BannerPaleolifeDesktopEn.style.display = 'none';  
          BannerExplicativaDesktopEn.style.display = 'none';  
         BannerPaleolifeMovilEn.style.display = 'block'; 
         BannerExplicativaMovilEn.style.display = 'block';  
        }
      if (window.innerWidth >= 761) {
                  BannerPaleolifeDesktopEn.style.display = 'block';  
          BannerExplicativaDesktopEn.style.display = 'block';  
         BannerPaleolifeMovilEn.style.display = 'none'; 
         BannerExplicativaMovilEn.style.display = 'none';   
      }

     if (landings === 'no') {
        Link.href = "#Slider-template--16703710494960__featured_collection_eEyzFU";
      }  
     if (landings === 'yes') {
        Link.href = "https://paleolf.us/pages/offer";
      }    
     } 


  

  

if (BannerProductoDesktopSec !== null && BannerCFDesktopHome== null) {
    
      BannerProductoDesktopSec.src = urlBannerProductoDesktop;
      BannerProductoDesktopSec.style.display = 'block';  

  } 

        if (BannerProductoDesktopSecEn !== null) {
    
      BannerProductoDesktopSecEn.src = urlBannerProductoDesktopEn;
      BannerProductoDesktopSecEn.style.display = 'block';  

  } 


  if (BannerCFDesktop !== null) {
  BannerCFDesktop.src = urlBannerCFDesktop;
  BannerCFMovil.src = urlBannerCFMovil;
  BannerExplicativaDesktop.src = urlBannerExplicativaDesktop;
  BannerExplicativaMovil.src = urlBannerExplicativaMovil;  
  } 


  


   



     



}  

//FINAL CONDICIONAL PROMO ON //



//INICIO CONDICIONAL PROMO OFF //

if (promo === 'off') {


       if (BannerCFDesktop !== null) {
console.log('LOADED.........');
         console.log ('Home paleolife');
    BannerSliderhome.style.display = 'block'; 
       
         BannerCFDesktop.style.display = 'none';  
         BannerExplicativaDesktop.style.display = 'none';  
         BannerCFMovil.style.display = 'none'; 
         BannerExplicativaMovil.style.display = 'none'; 
        
         ContenedorBannersHomeEs.style.display = 'none'; 
    
  } 


         if (BannerPaleolifeDesktopEn !== null) {
        
console.log('home .us');
         BannerSliderhomeEn.style.display = 'block'; 
           
         BannerPaleolifeDesktopEn.style.display = 'none'; 
           BannerPaleolifeMovilEn.style.display = 'none';
         BannerExplicativaDesktopEn.style.display = 'none';  
          
         BannerExplicativaMovilEn.style.display = 'none'; 
    
  } 

  

    if (BannerProductoDesktop !== null) {

     if (window.innerWidth <= 760) {
         BannerProductoMovil.style.display = 'none';  
        }
      if (window.innerWidth >= 761) {
          BannerProductoDesktop.style.display = 'none';  
      }
    } 


  if (BannerCFDesktopHome !== null) {
      
   if (window.innerWidth <= 760) {
         BannerCFMovilHome.style.display = 'none';  
         BannerCFDesktopHome.style.display = 'none'; 
        }
    if (window.innerWidth >= 761) {
          BannerCFDesktopHome.style.display = 'none';  
          BannerCFMovilHome.style.display = 'none'; 
      }
  } 


    if (BannerProductoDesktopEn !== null) {
      
     if (window.innerWidth <= 760) {
         BannerProductoMovilEn.style.display = 'none';  
        }
      if (window.innerWidth >= 761) {
          BannerProductoDesktopEn.style.display = 'none';  
      }
     } 

      if (BannerProductoDesktopSec !== null && BannerCFDesktopHome== null) {
      BannerProductoDesktopSec.style.display = 'none';  

  } 

        if (BannerProductoDesktopSecEn !== null) {
      BannerProductoDesktopSecEn.style.display = 'none';  

  } 


  if (BannerCFDesktop !== null) {
  BannerCFDesktop.src = urlBannerCFDesktop;
  BannerCFMovil.src = urlBannerCFMovil;
  BannerExplicativaDesktop.src = urlBannerExplicativaDesktop;
  BannerExplicativaMovil.src = urlBannerExplicativaMovil;  
  } 




  if (videoSamar !== null) {
  videoSamar.style.display = 'block';  
     if (window.innerWidth <= 760) {
         BannerSamarMovil.style.display = 'none'; 
         BannerExplicativaSamarMovil.style.display = 'none'; 
        }
    if (window.innerWidth >= 761) {
        BannerSamarDesktop.style.display = 'none'; 
        BannerExplicativaSamarDesktop.style.display = 'none'; 
    }
  } 
 


  if (videoCusi !== null) {
  videoCusi.style.display = 'block';  
         if (window.innerWidth <= 760) {
           BannerCusiMovil.style.display = 'none'; 
          BannerExplicativaMovil.style.display = 'none'; 
        }
    if (window.innerWidth >= 761) {
  BannerCusiDesktop.style.display = 'none'; 
    
    BannerExplicativaDesktop.style.display = 'none'; 
    }
  }

} 

//FINAL CONDICIONAL PROMO OFF //







if (promoSamar === 'on') {
  if (videoSamar !== null) {
  videoSamar.style.display = 'none';  
  BannerSamarDesktop.src = urlBannerSamarDesktop;
  BannerSamarMovil.src = urlBannerSamarMovil;
  BannerExplicativaSamarDesktop.src = urlBannerExplicativaSamarDesktop;
  BannerExplicativaSamarMovil.src = urlBannerExplicativaSamarMovil; 

     if (landings === 'no') {
        Link.href = "#ProductGridContainer";
      }  
     if (landings === 'yes') {
        Link.href = "https://paleolf.com/pages/oferta-doctora-samar";
      }      

     if (window.innerWidth <= 760) {
         BannerSamarMovil.style.display = 'block'; 
         BannerExplicativaSamarMovil.style.display = 'block'; 
        }
    if (window.innerWidth >= 761) {
        BannerSamarDesktop.style.display = 'block'; 
        BannerExplicativaSamarDesktop.style.display = 'block'; 
    }
  } 
}   

 
if (promoCusi === 'on') {     
  if (videoCusi !== null) {
  videoCusi.style.display = 'none';  
  BannerCusiDesktop.src = urlBannerCusiDesktop;
  BannerCusiMovil.src = urlBannerCusiMovil;
  BannerExplicativaDesktop.src = urlBannerExplicativaDesktop;  
  BannerExplicativaMovil.src = urlBannerExplicativaMovil;

     if (landings === 'no') {
        Link.href = "#ProductGridContainer";
      }  
     if (landings === 'yes') {
        Link.href = "https://paleolf.com/pages/oferta-cusi";
      }  

    
         if (window.innerWidth <= 760) {
           BannerCusiMovil.style.display = 'block'; 
          BannerExplicativaMovil.style.display = 'block'; 
        }
    if (window.innerWidth >= 761) {
  BannerCusiDesktop.style.display = 'block'; 
    
    BannerExplicativaDesktop.style.display = 'block'; 
    }
  } 
}


if (promoErika === 'on') {   
    if (ImageErika !== null) {

      ImageErika.style.display = 'none'; 
      ImageErikaDesktop.style.display = 'none'; 
      BannerErikaDesktop.src = urlBannerErikaDesktop;
      BannerErikaMovil.src = urlBannerErikaMovil;

        BannerExplicativaDesktop.src = urlBannerExplicativaDesktop;
        BannerExplicativaMovil.src = urlBannerExplicativaMovil; 


      if (landings === 'no') {
        Link.href = "#shopify-section-template--18504702296299__custom_liquid_HLxkyr ";
      }  
     if (landings === 'yes') {
        Link.href = "https://paleolf.com/pages/oferta-erika";
      }  
      
 
       if (window.innerWidth <= 760) {
       
          BannerExplicativaDesktop.style.display = 'none';  
         BannerExplicativaMovil.style.display = 'block';
         BannerErikaMovil.style.display = 'block';
         
        }
      if (window.innerWidth >= 761) {
      
         BannerExplicativaMovil.style.display = 'none'; 
          BannerExplicativaDesktop.style.display = 'block';
        BannerErikaDesktop.style.display = 'block'; 
      }

      
  } 
}


  
//BannerExplicativaDesktop.style.display = 'none'; 
//BannerExplicativaMovil.style.display = 'none'; 

//BannerExplicativaSamarDesktop.style.display = 'none'; 
//BannerExplicativaSamarMovil.style.display = 'none'; 


function obtenerEstadoDePromoCusi() {

    return 'off'; 
}


function obtenerEstadoDePromoSamar() {

    return 'off'; 
}

function obtenerEstadoDePromoErika() {

    return 'off'; 
}


function obtenerEstadoDePromo() {

    return 'off'; 
}

function landings() {

    return 'no'; 
}



  var validUrls = [
    'https://paleolf.com/pages/oferta',
    'https://paleolf.com/pages/oferta-especial',
    'https://paleolf.com/pages/oferta-cusi',
    'https://paleolf.com/pages/oferta-doctora-samar',
    'https://paleolf.com/pages/oferta-erika',
    'https://paleolf.us/pages/offer'
];

  var currentUrl = window.location.href;
  
//if (promo === 'off' && validUrls.includes(currentUrl)) {
   // window.location.href = "https://paleolf.com/products/kit-detox-desinflamatorio";
  //document.body.style.display = 'none';
//}

